import {FormControl, Grid, Tooltip} from "@material-ui/core";
import {MuiPickersUtilsProvider, DatePicker, DateTimePicker, KeyboardDatePicker} from "@material-ui/pickers"
import React, {useEffect, useState} from "react";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

const formatValueForDatePicker = (value) => {
    if (value && (typeof value === 'string' || value instanceof String)) {
        return new Date(value)
    }
    return value
}


const DatePickerInput = (
    {withTime, value, handleOnChange, name, label, required, errorMessage, ...props}
) => {

    return (
        <FormControl fullWidth>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {
                    withTime ?
                        <DateTimePicker
                            required
                            value={value}
                            onChange={handleOnChange}
                            label={label}
                            name={name}
                            {...props}>
                        </DateTimePicker>
                        :
                        <DatePicker
                            value={value}
                            onChange={handleOnChange}
                            label={label}
                            required
                            name={name}
                            format="yyyy-MM-dd"
                            {...props}
                        />
                }

            </MuiPickersUtilsProvider>
        </FormControl>
    )
}

export const MuiDateRangePickerInputWithoutTZ = (
    {value, handleStartChange, handleEndChange, name, spacing, tooltipText, ...props}
) => {
    const [inputValueStart, setInputValueStart] = useState();
    const [inputValueEnd, setInputValueEnd] = useState();

    const onDateChangeStart = (date, value) => {
        setInputValueStart(value);
        handleStartChange(value);
    };

    const onDateChangeEnd = (date, value) => {
        setInputValueEnd(value);
        handleEndChange(value);
    };

    useEffect(() => {
        setInputValueStart(value?.start ? moment(value.start).format("YYYY-MM-DD") : null)
        setInputValueEnd(value?.end ? moment(value.end).format("YYYY-MM-DD") : null)
    }, [value.start, value.end])

    return (
        <FormControl fullWidth>
            <Grid container spacing={spacing}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid item sm={12}>
                        <Tooltip title={tooltipText || ""} classes={!tooltipText && {popper: 'display-none'}}>
                            <span className={`date-range-filter-label ${tooltipText && 'help-cursor'}`}>{name}</span>
                        </Tooltip>
                    </Grid>
                    <Grid item sm={6}>
                        <KeyboardDatePicker
                            variant="filled"
                            margin="normal"
                            value={formatValueForDatePicker(value?.start) || null}
                            format="yyyy-MM-dd"
                            inputValue={inputValueStart}
                            onChange={onDateChangeStart}
                            label="From"
                            name={name}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            className={props.className}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <KeyboardDatePicker
                            variant="filled"
                            margin="normal"
                            format="yyyy-MM-dd"
                            value={formatValueForDatePicker(value?.end) || null}
                            inputValue={inputValueEnd}
                            onChange={onDateChangeEnd}
                            label="Till"
                            name={name}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            className={props.className}
                        />
                    </Grid>
                </MuiPickersUtilsProvider>
            </Grid>
        </FormControl>
    )
}

export const MuiDateRangePickerInput = (
    {value, handleStartChange, handleEndChange, name, spacing, tooltipText, ...props}
) => {

    const onHandleStart = (value) => {
        const date = new Date(value);
        const offset = date.getTimezoneOffset() / 60;
        date.setUTCHours(offset,0,0,0);
        handleStartChange(date);
    }

    const onHandleEnd = (value) => {
        const date = new Date(value);
        const offset = date.getTimezoneOffset() / 60;
        date.setUTCHours(23 + offset,59,59,999);
        handleEndChange(date);
    }

    return (
        <FormControl fullWidth>
            <Grid container spacing={spacing}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid item sm={12}>
                        <Tooltip title={tooltipText || ""} classes={!tooltipText && {popper: 'display-none'}}>
                            <span className={`date-range-filter-label ${tooltipText && 'help-cursor'}`}>{name}</span>
                        </Tooltip>
                    </Grid>
                    <Grid item sm={6}>
                        <KeyboardDatePicker
                            variant="filled"
                            margin="normal"
                            value={formatValueForDatePicker(value?.start) || null}
                            onChange={onHandleStart}
                            label="From"
                            name={name}
                            format="yyyy-MM-dd"
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            className={props.className}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <KeyboardDatePicker
                            variant="filled"
                            margin="normal"
                            value={formatValueForDatePicker(value?.end) || null}
                            onChange={onHandleEnd}
                            label="Till"
                            name={name}
                            format="yyyy-MM-dd"
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            className={props.className}
                            maxDate={props.maxDate ? props.maxDate : undefined}
                        />
                    </Grid>
                </MuiPickersUtilsProvider>
            </Grid>
        </FormControl>
    )
}

export const DatePickerInputWithoutTZ = (
    {withTime, value, handleOnChange, name, label, required, errorMessage, ...props}
) => {

    const formatValueWithoutTZ = (value) => {
        if (value && (typeof value === 'string' || value instanceof String)) {
            const dateParts = value.split('T')[0].split('-');
            if (dateParts.length === 3) {
                const year = parseInt(dateParts[0], 10);
                const month = parseInt(dateParts[1], 10) - 1;
                const day = parseInt(dateParts[2], 10);
                return new Date(year, month, day);
            }
            return new Date(value)
        }
        return value
    }

    const handleDateChange = (date) => {
        if (!withTime && date) {
            const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            handleOnChange(localDate);
        } else {
            handleOnChange(date);
        }
    };

    return (
        <FormControl fullWidth>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {
                    withTime ?
                        <DateTimePicker
                            required={required}
                            value={formatValueWithoutTZ(value)}
                            onChange={handleOnChange}
                            label={label}
                            name={name}
                            {...props}>
                        </DateTimePicker>
                        :
                        <DatePicker
                            value={formatValueWithoutTZ(value)}
                            onChange={handleDateChange}
                            label={label}
                            required={required}
                            name={name}
                            format="yyyy-MM-dd"
                            {...props}
                        />
                }

            </MuiPickersUtilsProvider>
        </FormControl>
    )
}

export default DatePickerInput;